import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'gb-empty-state-fridge',
  templateUrl: './gb-empty-state-fridge.component.html',
  styleUrls: ['./gb-empty-state-fridge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbEmptyStateFridgeComponent {}
